// @flow

import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { getTranslate }     from 'react-localize-redux';
import { clearAuthMsg }     from 'actions/session/authMsg';
import { resetPassword }    from 'actions/session/userAuth';
import AuthMsg              from '../authMsg/authMsg.js';
import toolHelper           from 'helpers/tools.helper';
import validationHelper     from 'helpers/validation.helper';
import documentHelper       from 'helpers/document.helper';
import queryString          from 'query-string';
import './new.css';

class NewPassword extends Component {

  urlQueryString = null;

  state = {
    headers_access_token  : '',
    headers_client        : '',
    headers_uid           : '',

    confirmationMatch     : true,
    password              : '',
    password_repeat       : '',
    emailValid            : false,
    formValid             : true,
    isCapslock            : false,
    plainPassword         : false,
    passwordMinimalReq    : false,
    passwordStrengthText  : '',
    passwordStrengthLevel : 0,
    strength              : 0
  };

  // Component constructor
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderConfirmationAlert = this.renderConfirmationAlert.bind(this);
  }

  componentDidMount = () => {
    let query_string = queryString.parse(this.props.location.search);
    this.setAuthHeaders(query_string.token, query_string.uid, query_string.client_id);
    this.urlQueryString = query_string;
  }

  componentWillMount() {
    const { translate } = this.props;
    // Document page title
    documentHelper.setTitle(translate('session.password_reset.title_document'));
  }

  handleChange = (e) => {
    //Save data to state
    const { id, value } = e.target;
    this.setState({ [id]: value });

    // Check for password requirements
    if( id === 'password' ) {
      this.passwordStrengthMeter(value);
    }
  }

  // check if password confirmation field equal to password field
  handleConfirmInput = (e) => {
    const { value } = e.target;
    this.setState({password_repeat: value, confirmationMatch: this.state.password === value});
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const { password, passwordMinimalReq, headers_uid, headers_client, headers_access_token } = this.state;
    const { dispatch, history } = this.props;

    dispatch(clearAuthMsg());
    this.setState({ formValid:true });

    // Create register post
    if( passwordMinimalReq ) {
      // Check if reset password token exists
      let reset_password_token = this.urlQueryString ? this.urlQueryString.reset_password_token : '';
      // Set other headers if they exists
      let headers = { 'uid': headers_uid, 'client': headers_client, 'access-token': headers_access_token };
      dispatch(resetPassword(password, reset_password_token, headers, history)).then(res => {
        if( this.props.authMsg && this.props.authMsg.message !== '' ) {
          this.setState({ formValid: false });
        }
      });
    }
  }

  // Show or hide plain password input
  togglePlainPassword = () => {
    this.setState({plainPassword: !this.state.plainPassword});
  }

  // Capslock detection
  capslockDetect = (e) => {
    let isCapslock = toolHelper.isCapslock(e);
    this.setState({ isCapslock: isCapslock });
  }

  // Password strength meter
  passwordStrengthMeter = (value) => {
    this.setState({ passwordMinimalReq: false });

    var inputVal = value;

    this.setState({ strength: validationHelper.passStrengthMeter(inputVal) });
    this.setState({ passwordStrengthLevel: this.state.strength });

    // Check for minimal requirements
    var isPasswordMinReq = validationHelper.passMinRequirements(inputVal);
    this.setState({ passwordMinimalReq: isPasswordMinReq });

    let passwordStrengthLevel_ = this.state.passwordStrengthLevel;
    let passwordStrengthText_  = '';

    if( passwordStrengthLevel_ <= 3 ) {
      passwordStrengthText_ = this.props.translate('session.common.password_strength.low');
    } else if( passwordStrengthLevel_ === 4 ) {
      passwordStrengthText_ = this.props.translate('session.common.password_strength.medium');
    } else {
      passwordStrengthText_ = this.props.translate('session.common.password_strength.strong');
    }

    this.setState({ passwordStrengthText: passwordStrengthText_ });
  }

  // Set auth headers
  setAuthHeaders = (token, uid, client) => {
    this.setState({
      headers_access_token: (token || ''),
      headers_uid         : (uid.replace(' ', '+') || ''),
      headers_client      : (client || '')
    });
  }

  renderConfirmationAlert = () => {
    const { translate } = this.props;

    if (this.state.confirmationMatch === false) {
      return (
        <div className="alert alert-danger">
          <p>{translate('session.error.error_not_equal')}</p>
        </div>
      )
    } else {
      return null;
    }
  }

  render() {

    const { password,
            password_repeat,
            formValid,
            isCapslock,
            plainPassword,
            passwordStrengthText,
            passwordStrengthLevel,
            passwordMinimalReq } = this.state;
    const { translate } = this.props;

    // Is Capslock on?
    let isCapslockRender;
    if( isCapslock ) {
      isCapslockRender = (<CapsLockRender {...this.props} />);
    }

    // Show or hide plain password input
    let showPlainPasswordRender = plainPassword ? (<i className="fa fa-eye" onClick={this.togglePlainPassword} />) : (<i className="fa fa-eye-slash" onClick={this.togglePlainPassword} />);

    return (
      <div className="reset-password">
        <div className="new">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-sm-8 col-sm-offset-2 text-center">
                <div className="top-header">
                  <h2>{translate('session.password_reset.title')}</h2>
                </div>
                <div className="top-header-infobox">
                  <i className="icon-bell"></i>
                  <p>{translate('session.password_reset.text_slogan')}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="row main-content">
            <div className="col-xs-12 col-sm-8 col-sm-offset-2">
              <div className="row">
                <div className="col-xs-12">
                  <form name="form_resetpassword" className="login-form" onSubmit={this.handleSubmit}>
                    <div className={'form-group has-float-label ' + (isCapslock === true ? 'has-error' : '')}>
                      <span className="eye-icon">
                        {showPlainPasswordRender}
                      </span>
                      <input type={plainPassword ? 'text' : 'password'} id="password" value={password} onChange={this.handleChange} onKeyDown={this.capslockDetect} autoComplete="off" name="password" className="form-control" required />
                      <label>{translate('session.field.field_password')}</label>
                      <span className="password-icon" />
                      <span className={passwordMinimalReq ? 'validation-check' : ''}></span>
                    </div>
                    <div className="form-group">
                      <ul className="password-strength-meter">
                        <li className="bg-danger highlighted"></li>
                        <li className={"bg-danger " + (passwordStrengthLevel >= 1 ? 'highlighted' : '')}></li>
                        <li className={"bg-danger " + (passwordStrengthLevel >= 1 ? 'highlighted' : '')}></li>
                        <li className={"bg-warning " + (passwordStrengthLevel >= 2 ? 'highlighted' : '')}></li>
                        <li className={"bg-warning " + (passwordStrengthLevel >= 2 ? 'highlighted' : '')}></li>
                        <li className={"bg-warning " + (passwordStrengthLevel >= 3 ? 'highlighted' : '')}></li>
                        <li className={"bg-success " + (passwordStrengthLevel >= 4 ? 'highlighted' : '')}></li>
                        <li className={"bg-success " + (passwordStrengthLevel >= 4 ? 'highlighted' : '')}></li>
                        <li className={"bg-success " + (passwordStrengthLevel >= 5 ? 'highlighted' : '')}></li>
                      </ul>
                      <small>{passwordStrengthText}</small>
                    </div>
                    <div className="form-group">
                      {!passwordMinimalReq &&
                      <div className="alert alert-danger">
                        <p>{translate('session.error.error_password_limits')}</p>
                      </div>
                      }
                      <div className="alert alert-success password-must-contain">
                        <strong>{translate('session.common.texts.text_password_must')}</strong>
                        <p>{translate('session.common.texts.text_password_contains')}</p>
                      </div>
                      {isCapslockRender}
                    </div>
                    {!formValid &&
                      <div className="error-float-message alert alert-danger">
                        <i className="icon-bell"></i>
                        <span><AuthMsg /></span>
                      </div>
                    }
                    { this.renderConfirmationAlert() }
                    <div className="form-group has-float-label">
                      <span className="eye-icon">
                        {showPlainPasswordRender}
                      </span>
                      <input type={plainPassword ? 'text' : 'password'} id="password_repeat" value={password_repeat} onChange={this.handleConfirmInput} onKeyDown={this.capslockDetect} autoComplete="off" name="password_repeat" className="form-control" required />
                      <label>{translate('session.field.field_password_repeat')}</label>
                      <span className="password-icon" />
                    </div>
                    <div className="form-group">
                      <div className="submit-wrap">
                        <div className="button-wrap">
                          <input type="submit" name="register" value={translate('session.common.button_reset_password')} disabled={!this.state.confirmationMatch}/>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="row bottom">
            <div className="col-xs-12 col-lg-3 margin-center">
              <div className="bottom-box text-center">
                <div className="nick-bg-armdown"></div>
                <div className="info-box">
                  <strong>{translate('session.common.texts.text_what_to_do_next')}</strong>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-sm-offset-3">
              <div className="bottom-box text-center">
                <div className="circle-arrow-group">
                  <div className="circle-arrow-right">
                    <div className="car-text text-center"><strong>{translate('session.password_reset.text_check_your_email')}</strong><p>{translate('session.password_reset.text_inbox_or_spam')}</p></div>
                    <i className="car-top-left"></i>
                    <i className="car-bottom-left"></i>
                    <i className="car-middle"></i>
                    <i className="car-right"></i>
                  </div>
                  <div className="circle-arrow-left">
                    <div className="cal-text text-center"><i className="fa fa-check"></i><span>{translate('session.password_reset.text_activate_and_set_password')}</span></div>
                    <i className="cal-top-right"></i>
                    <i className="cal-bottom-right"></i>
                    <i className="cal-middle"></i>
                    <i className="cal-left"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-sm-offset-3 text-center fs-14">{translate('session.common.hint.hint_checkout_faq')}</div>
          </div>

        </div>
      </div>

    );

  }
}

class CapsLockRender extends React.Component {
  render() {
    const { translate } = this.props;

    return(
      <div className="alert alert-danger">
        <p>{translate('session.error.error_capslock')}</p>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translate : getTranslate(state.locale),
  authMsg   : state.authMsg
});

export default connect(mapStateToProps)(NewPassword);



// WEBPACK FOOTER //
// ./src/components/session/resetPassword/new.js